import {Component, Input, OnInit} from '@angular/core';
import {Instance} from 'src/app/models/instance/instance';
import {Sandbox} from 'src/app/models/sandbox';
import {ServiceCardInfo} from 'src/app/models/service/service-card-info';
import {toBoolean} from 'src/app/services/util/utils';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent implements OnInit {

  @Input() serviceCardInfo: ServiceCardInfo;

  isSandboxCard: boolean;
  sandbox: Sandbox;

  constructor() {
  }

  ngOnInit(): void {
    this.isSandboxCard = this.isDemoBlueprint();

    if (this.isSandboxCard) {
      const demoInstance = this.getDemoInstance();
      this.sandbox = {
        service: this.serviceCardInfo.service,
        instance: demoInstance
      };
    }
  }

  /**
   * Checks if the blueprint is demo blueprint
   *
   * @returns true if the blueprint is demo blueprint, false otherwise
   */
  isDemoBlueprint(): boolean {
    return toBoolean(this.serviceCardInfo?.blueprint?.demo);
  }

  /**
   * Finds the demo instance if present
   *
   * @returns the demo instance if found
   */
  getDemoInstance(): Instance {
    return this.serviceCardInfo?.instances?.find(instance => instance.blueprintId === this.serviceCardInfo?.blueprint?.id);
  }
}
